import './App.css';
import Navbar from './Components/Navbar';
import AllRoutesPages from "./Pages/AllRoutesPages"
function App() {
  return (
    <div className="App">
      <Navbar/>
      <AllRoutesPages/>
    </div>
  );
}

export default App;
